import React from "react";
import { PATH } from "../../globals/app-constants";
import FooterContact from "../../component/FooterContact";
import { Link } from "react-router-dom";
import { useState } from "react";


const Portfolio = () => {
    const [hideLoadMore, setHideLoadMore] = useState(false);
    const [initialImagesCount, setInitialImagesCount] = useState(6);
    // let initialImagesCount = 7;
    const card = [
        {
            img: PATH.img.shopAppThumbnail,
            title: 'Shop App',
            subText: `Shop Management Solution offers an advanced Inventory Management system for L&T + Bistro, WIWO, and E-commerce sections. The platform includes a Customer E-commerce Application for seamless product and bistro dish orders, a versatile Store Manager Application with multiple roles, and a Planogram feature for efficient stock monitoring.`,
            tag: ['Python', 'Django', 'RESTful APIs', `Cloudpick's API`],
            fontSize: 'large',
            title_path: '/case-studies/shopapp-app'
        },
        {
            img: PATH.img.CVShieldThumbnail,
            title: 'CV-Shield',
            subText: `Proglint led the development of an advanced Face Recognition-based Attendance System, transforming traditional attendance tracking methods. Utilizing sophisticated facial recognition algorithms such as OpenCV and ArcFace, the system efficiently captures, analyzes, and verifies individuals' faces, ensuring precise attendance recording.`,
            tag: ['OpenCV', 'Python', 'ArcFace Facial Recognition Algorithms'],
            fontSize: 'small',
            title_path: '/case-studies/cv-shield',

        },
        {
            img: PATH.img.JedediahsThumbnail,
            title: 'Jedediahs',
            subText: `Proglint pioneered the development of Jedediah, an innovative E-commerce application offering diverse checkout options to enrich user experiences. With versatile interfaces - web, mobile, manned, and vision-based checkouts - Jedediah provides a holistic solution for online shopping, catering to groceries and bistro products. This comprehensive platform ensures seamless shopping experiences for both guests and registered users.`,
            tag: ['Web Development', 'Mobile App Development', 'Computer Vision'],
            fontSize: 'small',
            title_path: '/case-studies/jedidahs'

        },
        {
            img: PATH.img.FreshersAllThumbnail,
            title: 'Freshers-All',
            subText: `FreshersAll, a leading job and current affairs portal, leverages cutting-edge technologies in website development to offer an enriched user experience. With its foundation on React, a dynamic JavaScript library for crafting user interfaces, FreshersAll ensures an interactive and engaging platform for job seekers. Moreover, the integration of GraphQL enhances data retrieval efficiency, allowing seamless access to various sources like internal databases and third-party APIs.`,
            tag: ['React Framework', 'GraphQL', 'AWS', 'GCP', 'CMS'],
            fontSize: 'large',
            title_path: '/case-studies/freshers-all-app'

        },
        {
            img: PATH.img.CVSThumbnail,
            title: 'CVS',
            subText: 'The Smart Fridge Management System revolutionizes retail with computer vision and deep learning. It enables automatic cart creation, planogram management, and seamless vendor onboarding, delivering an enhanced shopping experience.',
            tag: ['Computer Vision', 'Deep Learning', 'Automated Purchasing'],
            fontSize: 'large',
            title_path: '/case-studies/cvs'
        },
        {
            img: PATH.img.cosfymartThumbnail,
            title: 'Cosfymart',
            subText: 'Proglint spearheaded the development of Cosfymart, an integrated mobile and web-based E-commerce Platform facilitating swift transactions between retail customers and vendors. This solution harmonizes the shopping experience, empowering registered users to effortlessly purchase a myriad of products from various vendors with just a few taps or clicks.',
            tag: ['React Native', 'Node.js', 'MongoDB', 'HTML5', 'CSS3', 'JavaScript'],
            fontSize: 'small',
            title_path: '/case-studies/cosfymart-app'
        },
        {
            img: PATH.img.treuxThumbnail,
            title: 'Treux',
            subText: 'The Equinox app redefines employee management, offering a centralized platform for quick and efficient daily operations. Simplifying tasks with its user-friendly interface, it allows seamless tracking of requests, approvals, and HR services, empowering users with on-the-go actions.',
            tag: ['Swift (iOS)', 'Kotlin (Android)', 'Node.js', 'MongoDB', 'Selenium', 'Jest Framework'],
            fontSize: 'small',
            title_path: '/case-studies/treux-app'
        },
        {
            img: PATH.img.TapandGoThumbanail,
            title: 'Tap & Go',
            subText: 'The Tap and Go application revolutionizes WIWO store access, offering a seamless, contactless experience. Customers use their debit or credit cards to pre-authorize entry, shop hassle-free, and conveniently pay upon exit.',
            tag: ['NFC (Near Field Communication)', 'Payment APIs (Stripe, PayPal)', 'React Native', 'Backend (Node.js)', 'Database (MongoDB)'],
            fontSize: 'large',
            title_path: '/case-studies/tap-and-go'
        },
        {
            img: PATH.img.PaulFashionThumbnail,
            title: 'Pauls-Fashion',
            subText: `Paul's Fashion, a renowned Thai tailor, expanded its services by launching an e-commerce platform. The app empowers customers to customize clothing items, from shirts to suits, offering a seamless tailoring experience.`,
            tag: ['React Native', 'Backend(Node.js)', 'Database (MySQL)', 'Payment Gateway Integration (Stripe)'],
            fontSize: 'large',
            title_path: '/case-studies/pauls-fashion'
        },
        {
            img: PATH.img.EquionxThumbnail,
            title: 'Equionx',
            subText: 'The Equinox app redefines employee management, offering a centralized platform for quick and efficient daily operations. Simplifying tasks with its user-friendly interface, it allows seamless tracking of requests, approvals, and HR services, empowering users with on-the-go actions.',
            tag: ['React Native', 'Firebase', 'RESTful API'],
            // tag4: 'Computer Vision',
            fontSize: 'small',
            title_path: '/case-studies/equinux'
        },
        {
            img: PATH.img.SmartFridgeThumbnail,
            title: 'Smart Fridge',
            subText: 'Proglint pioneered the development of an innovative smart fridge leveraging computer vision and deep learning algorithms. This smart fridge not only facilitated automated purchasing but also introduced advanced features like inventory and planogram management, vendor onboarding, and comprehensive sales reporting.',
            tag: ['DeepVis Cart Creation', 'Computer Vision', 'Deep Learning Algorithms', 'Automated Purchasing Systems'],
            fontSize: 'small',
            title_path: '/case-studies/smart-fridge'
        },
        {
            img: PATH.img.losspreventionThumbnail,
            title: 'Loss Prevention',
            subText: 'Proglint spearheaded the development of an innovative Loss-Prevention Algorithm catering to the automation sector within the retail domain. The algorithm was designed to augment the security of self-checkout kiosks in supermarkets, mitigating the risk of fraudulent activities. By implementing a robust and efficient system, customers could confidently control their purchasing process while preventing potential losses due to unauthorized actions.',
            tag1: ['Machine Learning', 'Computer Vision', 'Python'],
            // tag4: 'Computer Vision',
            fontSize: 'large',
            title_path: '/case-studies/loss-prevention'
        },
        {
            img: PATH.img.aladdinThumbnail,
            title: 'Aladdin',
            subText: `Proglint's Home Service project introduces a mobile-based solution connecting customers with proficient home service professionals. The app offers tailored service requests, managed by 'Aladdins' who match requests to the right 'Service Providers.' Admin oversees operations.`,
            tag: ['React Native', 'Node.js', 'OAuth 2.0', 'Firebase'],
            fontSize: 'large',
            title_path: '/case-studies/aladdin-app'
        },
        {
            img: PATH.img.QLMThumbnail,
            title: 'QLM',
            subText: 'Proglint collaborated with Qatar Life & Medical Insurance Company (QLM) and Oman Qatar Insurance Company (OQIC) to develop cutting-edge mobile applications facilitating insurance services for employees. The applications enable users to access benefits, track claims, download health certificates, locate healthcare providers via Google Maps, set medication reminders, and access essential health-related information seamlessly.',
            tag: ['Mobile Development (iOS, Android)', 'Google Maps API', 'Claim Management Software'],
            // tag4: 'Computer Vision',
            fontSize: 'small',
            title_path: '/case-studies/qlm-app'
        },
        {
            img: PATH.img.IntelThumbnail,
            title: 'Intel',
            subText: 'The Intel Vision Checkout application serves as the dedicated interface for the Vision Checkout kiosk E-commerce platform, providing a specialized shopping experience centered around Intel products. The application offers an intuitive user interface designed to cater specifically to Intel enthusiasts, enabling a seamless and secure shopping journey',
            tag: ['Secure File Transfer Protocol (SFTP) using WinSCP', 'Real-time Database Synchronization', 'Embedded Hardware Interface for Cash Machine Integration', 'Encrypted Payment Gateway API Integration'],

            fontSize: 'small',
            title_path: '/case-studies/intel-vision-checkout'
        },
        {
            img: PATH.img.NNBThumbnail,
            title: 'Nourish-N-Bloom',
            subText: 'Proglint spearheaded the development of an advanced Inventory Management System for Nourish & Bloom, integrating with SAP ERP for seamless control over ordering, stocking, and tracking inventory across multiple sections. Additionally, bespoke Customer E-commerce and Store Manager Applications were designed for streamlined operations.',
            tag: ['MySQL', 'MongoDB', 'SAP ERP Integration', 'React Native', 'React.js', 'Node.js'],
            fontSize: 'large',
            title_path: '/case-studies/nnb'
        },
        // {
        //     img: PATH.img.ProductBoxThumbnail,
        //     title: 'Product Box',
        //     subText: 'Product Box stands as an intuitive application designed to facilitate efficient product information management. It boasts a user-centric interface enabling hassle-free input and updates of crucial data such as images, weight, barcode, and dimensions.',
        //     tag: ['RealSense Depth Camera', 'Optical Character Recognition (OCR)', 'Image Processing (OpenCV)', 'Barcode Scanning API', 'Database Management (SQL)'],
        //     fontSize: 'small',
        //     title_path: '/case-studies/product-box-app'
        // },

        {
            img: PATH.img.LeelaKitchenThumbnail,
            title: 'Leela Kitchen',
            subText: `Experience a culinary transformation with Proglint's innovative solution tailored for Leela Kitchen. Our efficient ordering system redefines the customer journey, offering seamless dish selection and smart inventory management. Enhance your service with our cost-effective, tech-driven food ordering approach.`,
            tag: ['MySQL', 'MongoDB', 'React.js', 'Node.js'],
            fontSize: 'small',
            title_path: '/case-studies/leela-kitchen'
        },
        {
            img: PATH.img.CanteenThumbnail,
            title: 'Canteen Tap & Go ',
            subText: `Transforming canteen experiences, our Tap & Go app simplifies billing with QR technology. Seamlessly register cards, preauthorize amounts, and refund balances effortlessly. Elevate canteen convenience with our innovative mobile solution.`,
            tag: ['Python', 'Django ', ' RESTful APIs', `Cloudpick's API`],
            fontSize: 'small',
            title_path: '/case-studies/canteen-app'
        },
    ]
    const [portfolioCard, setPortfolioCard] = useState(card.slice(0, initialImagesCount))


    const loadMoreOnClick = () => {
        const currentCount = portfolioCard.length;
        const newCount = currentCount + initialImagesCount;
        let remainingImages = card?.slice(currentCount, newCount);
        let remaining = card?.length - newCount
        if (remaining < 8) {
            // initialImagesCount = remainingImages?.length
            setInitialImagesCount(remaining)
        }
        // debugger
        if (newCount === card?.length) {
            setHideLoadMore(true)
        }
        setPortfolioCard([...portfolioCard, ...remainingImages]);
    };

    return (
        <div>
            <div className="service_banner_h relative overflow-hidden">
                <div className="container mx-auto">
                    <div className="z-10 absolute bottom-6 lg:top-[30%]">
                        <h1 className="banner_title fSB text-white w-auto md:w-auto lg:max-w-xl">Portfolio</h1>
                    </div>
                </div>
                <div className="absolute right-0 w-full lg:w-4/6">
                    <img src={PATH.img.portfolioBanner} alt="banner" className="w-full h-full object-contain" />
                </div>
            </div>

            <div className="container mx-auto">


                <div className="portfolio grid grid-cols-12 gap-4 lg:gap-10 my-4 lg:my-10">
                    {portfolioCard?.map((card) => {
                        return (
                            <>
                                {card.fontSize === 'large' &&
                                    <>
                                        <div className="portfolio_card group w-full col-span-12 lg:col-span-8 lg:mb-0 relative overflow-hidden">
                                            <img src={card.img} alt="retail" className="w-full h-full object-cover bg-no-repeat" />
                                            <div className="w-full h-full cursor-pointer lg:flex absolute top-0 bg-gradient-to-b from-transparent to-gray-900 lg:group-hover:bg-gradient-to-b lg:group-hover:from-[#D9D9D9] lg:group-hover:to-[#D9D9D9]">
                                                <div className="flex flex-col justify-between lg:hidden w-full h-full px-3 py-3">
                                                    <span className="tags flex flex-row gap-2 flex-wrap lg:hidden">
                                                        {
                                                            card.tag?.map(v => <div className="py-1 px-2 rounded-sm bg-white text-black text-xs w-auto">{v}</div>)
                                                        }
                                                    </span>
                                                    <h2 className="portfolio_title text-xl md:text-3xl fB text-white cursor-pointer" onClick={() => window.location.reload()}><Link to={(card.title_path)}>{card.title}</Link></h2>
                                                </div>
                                                <div className="relative lg:group-hover:translate-y-0 transition-all ease-out duration-300 px-6 w-full h-full">
                                                    <div className="tags hidden lg:group-hover:flex flex-wrap flex-row gap-8 group-hover:top-0 py-6">
                                                        {
                                                            card.tag?.map(v => <div className="py-1 px-2 rounded-sm bg-white text-black text-xs w-auto">{v}</div>)
                                                        }
                                                    </div>
                                                    <h2 className="portfolio_title absolute bottom-10 group-hover:hidden text-xl md:text-3xl lg:text-5xl fB text-white group-hover:mb-5 lg:group-hover:text-hColor lg:group-hover:underline decoration-2 mt-3 cursor-pointer">{card.title}</h2>
                                                    <div className="invisible group-hover:visible">
                                                        <h2 className="portfolio_title text-xl md:text-3xl lg:text-5xl fB text-white mb-16 group-hover:mb-5 lg:group-hover:text-hColor lg:group-hover:underline decoration-2 mt-3 cursor-pointer" onClick={() => window.location.reload()}><Link to={(card.title_path)}>{card.title}</Link></h2>
                                                        <p className="hidden lg:block text-white text-lg group-hover:text-pColor fR">{card.subText}</p>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                        <p className="block col-span-12 w-full lg:hidden text-sm mb-4 z-30 text-pColor fR">{card.subText}</p>
                                    </>
                                }
                                {card.fontSize === 'small' &&
                                    <>
                                        <div className="portfolio_card group w-full col-span-12 lg:col-span-4 mb-3 lg:mb-0 relative overflow-hidden">
                                            <img src={card.img} alt="retail" className="w-full h-full object-cover bg-no-repeat" />
                                            <div className="w-full h-full cursor-pointer lg:flex absolute top-0 bg-gradient-to-b from-transparent to-gray-900 lg:group-hover:bg-gradient-to-b lg:group-hover:from-[#D9D9D9] lg:group-hover:to-[#D9D9D9]">
                                                <div className="flex flex-col justify-between lg:hidden w-full h-full px-3 py-3">
                                                    <span className="tags flex flex-row gap-2 flex-wrap lg:hidden">
                                                        {
                                                            card.tag?.map(v => <div className="py-1 px-2 rounded-sm bg-white text-black text-xs w-auto">{v}</div>)
                                                        }
                                                    </span>
                                                    <h2 className="portfolio_title text-xl md:text-3xl fB text-white cursor-pointer" onClick={() => window.location.reload()}><Link to={(card.title_path)}>{card.title}</Link></h2>
                                                </div>
                                                <div className="relative lg:group-hover:translate-y-0 transition-all ease-out duration-300 px-6 w-full h-full">
                                                    <div className="tags hidden group-hover:flex flex-wrap flex-row gap-3 group-hover:top-0 py-6">
                                                        {
                                                            card.tag?.map(v => <div className="py-1 px-2 rounded-sm bg-white text-black text-xs w-auto">{v}</div>)
                                                        }
                                                    </div>
                                                    <h2 className="portfolio_title absolute bottom-10 group-hover:hidden text-4xl fB text-white group-hover:mb-5 lg:group-hover:text-hColor lg:group-hover:underline decoration-2 mt-3 cursor-pointer" onClick={() => window.location.reload()}><Link to={(card.title_path)}>{card.title}</Link></h2>
                                                    <div className="invisible group-hover:visible">
                                                        <h2 className="portfolio_title text-3xl fB text-white group-hover:mb-5 lg:group-hover:text-hColor lg:group-hover:underline decoration-2 mt-3 cursor-pointer" onClick={() => window.location.reload()}><Link to={(card.title_path)}>{card.title}</Link></h2>
                                                        <p className="text-white text-sm group-hover:text-pColor fR">{card.subText}</p>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                        <p className="block col-span-12 lg:hidden text-sm mb-4 z-30 text-pColor fR">{card.subText}</p>
                                    </>}
                            </>
                        )
                    })}
                </div>
                {!hideLoadMore && <button onClick={() => loadMoreOnClick()} className="px-4 py-2 text-center border-gray-950 text-[#F26D55] fR text-xs border   rounded-full block m-auto mb-16">Load More...</button>}
                {/* {!hideLoadMore && <Btn value={'Load More...'} bgColor={'white'} onClick={() => loadMoreOnClick()}/>} */}

            </div>
            <FooterContact />
        </div>
    );
};
export default Portfolio;